export const ABOUT_SALAH_DATA = {
  en: {
    title: "",
    content: "About Dr. Salah Al Rashed",
    about: "About",
    name: "Salah AI",
    lastName: "Rashed",
    
    
  },
  ar: {
    title: "",
    content: "عن الدكتور صلاح الراشد",
    about: "عن",
    name: "صلاح ال",
    lastName: "راشد",
  },
};
export const ABOUT_SALAH = {
  en: [
    {
      title: "About Dr. Salah Al Rashed",
      content: ["Dr. Salah Al Rashed is a pioneer in the Arab world in the fields of personal development, spirituality, and human potential. Over the past decades, he has become one of the most influential voices guiding individuals and organizations toward transformation, awareness, and holistic well-being.",
        "As an author, thinker, and teacher, Dr. Salah has published numerous books, delivered thousands of lectures, and teaches tens of thousands of people across the globe. His unique approach blends psychology, spirituality, philosophy, and practical tools, making self-development accessible and relevant to everyday life. He is widely credited with introducing modern human development sciences and practices into the Arab region, where his work has inspired millions."],
      isSentence: true,
    },
    {
      title: "Leadership and Vision",
      content: [<> Dr. Salah is the <strong>Chairman of SmartsWay Co.,</strong>a pioneering company that develops innovative projects across the human development field. Under his leadership, SmartsWay has launched multiple platforms, training programs, and applications designed to support individuals on their journey of growth and transformation. 
</>],
      isSentence: true,
    },
    {
      title: "Philosophy and Contributions",
      content: ["Dr. Salah’s philosophy is rooted in the belief that every individual carries the potential for deep change and balance when provided with the right tools and guidance. He has consistently emphasized self-awareness, emotional healing, harmony, and resilience as the foundations of human flourishing.",
        <> Through initiatives like <strong>AskSalah,</strong> Dr. Salah continues to expand the reach of his teachings by integrating advanced artificial intelligence into coaching and personal guidance. The application brings his methodologies to a wider audience, offering people direct access to personalized experiences that support growth, healing, and transformation. </>
      ],
      isSentence: true,
    },
  ],
  ar: [
    {
      title: "عن الدكتور صلاح الراشد",
      content: ["يُعدّ الدكتور صلاح الراشد رائداً في العالم العربي في مجالات التنمية البشرية. وعلى مدى العقود الماضية، أصبح أحد أبرز الأصوات المؤثرة في توجيه الأفراد والمؤسسات نحو التحول والوعي والرفاهية الشاملة.",
        "بصفته مؤلفاً ومفكراً ومعلماً، نشر الدكتور صلاح العديد من الكتب، وألقى آلاف المحاضرات، وعلم عشرات الآلاف من الأشخاص حول العالم. ويتميّز نهجه الفريد بدمجه بين علم النفس والروحانية والفلسفة والأدوات العملية، مما جعل التنمية الذاتية أكثر قرباً وارتباطاً بحياة الناس اليومية. ويُنسب إليه على نطاق واسع فضل إدخال علوم وممارسات التنمية البشرية الحديثة إلى المنطقة العربية، حيث ألهمت أعماله ملايين الأشخاص."],
      isSentence: true,
    },
    {
      title: "القيادة والرؤية",
      content: ["الدكتور صلاح هو رئيس مجلس إدارة شركة سمارتسوي (SmartsWay Co.)، وهي شركة رائدة تطوّر مشاريع مبتكرة في مجال التنمية البشرية. وتحت قيادته، أطلقت سمارتسوي العديد من المنصات والبرامج التدريبية والتطبيقات المصممة لدعم الأفراد في رحلتهم نحو النمو والتحول."],
      isSentence: true,
    },
    {
      title: "الفلسفة والمساهمات",
      content: ["تنطلق فلسفة الدكتور صلاح الراشد من إيمانه بأن كل إنسان يحمل في داخله القدرة على التغيير العميق والتوازن، إذا ما توفرت له الأدوات والتوجيه الصحيح. وقد شدّد باستمرار على أهمية الوعي الذاتي، التشافي العاطفي، والانسجام، والمرونة كأساس لازدهار الإنسان.",
        "ومن خلال مبادرات مثل تطبيق اسأل صلاح (AskSalah)، يواصل الدكتور صلاح توسيع نطاق تأثير تعاليمه عبر دمج الذكاء الاصطناعي المتقدم في مجال التدريب والإرشاد الشخصي. ويتيح التطبيق وصولاً مباشراً إلى خبراته ومنهجيته لعدد أكبر من الناس، مما يوفّر لهم تجارب شخصية تدعم النمو والتشافي والتحول."],
      isSentence: true,
    },
  ],
};
